import { api } from '../api';
import {
  GET_TICKET,
  GET_TICKETS,
  GET_TICKET_CATEGORIES,
  NEW_TICKET
} from '../../constants';
import {
  GetTicketBodyRequest,
  GetTicketBodyResponse,
  GetTicketCategoriesResponse,
  GetTicketsResponse,
  NewTicketBodyRequest,
  NewTicketBodyResponse
} from './types';

export const ticketSlice = api.injectEndpoints({
  endpoints: (build) => ({
    getTickets: build.query<
      GetTicketsResponse,
      { offset: number; limit: number; infinit: boolean }
    >({
      query: (data) => {
        return {
          url: GET_TICKETS,
          method: 'POST',
          body: data
        };
      },
      transformResponse: (response: GetTicketsResponse, meta, arg) => {
        Object.assign(response.responses, {
          ...response.responses,
          infinit: arg.infinit
        });
        return response;
      },
      merge: (currentCache, newItems) => {
        const isInfinit = newItems.infinit;
        if (isInfinit) {
          currentCache?.responses?.push(...newItems.responses);
        } else {
          currentCache.responses = newItems.responses;
        }
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg;
      },
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      providesTags: ['getTickets']
    }),
    newTickets: build.mutation<NewTicketBodyResponse, NewTicketBodyRequest>({
      query: (data) => {
        return {
          url: NEW_TICKET,
          method: 'POST',
          body: data
        };
      },
      invalidatesTags: ['getTickets']
    }),
    getTicket: build.query<GetTicketBodyResponse, GetTicketBodyRequest>({
      query: (data) => {
        return {
          url: GET_TICKET,
          method: 'POST',
          body: data
        };
      },
      providesTags: ['getTicket']
    }),
    getTicketCategories: build.query<GetTicketCategoriesResponse, void>({
      query: () => {
        return {
          url: GET_TICKET_CATEGORIES,
          method: 'POST',
          body: {}
        };
      }
    })
  }),
  overrideExisting: false
});

export const {
  useGetTicketsQuery,
  useLazyGetTicketsQuery,
  useGetTicketCategoriesQuery,
  useNewTicketsMutation,
  useGetTicketQuery,
  useLazyGetTicketQuery
} = ticketSlice;
